<template>
  <div class="dt-page signup-page">
    <div class="signup-container">
      <div class="left-box">
        <div class="logo">
          <img style="cursor: pointer;" :src="'./static/images/Details_logo_280.png'" alt srcset />
        </div>
        <div class="text-content">
          <span>backoffice solutions for independents.</span>
          <span>let details work for you!!</span>
        </div>
      </div>
      <div class="right-box">
        <div id="logo-main-box" :style="{ 'margin-top': paddingTop }" class="logo-box logo-main-box">

          <img class="logo-image" :src="previewImage" />


        </div>
        <v-stepper :value="wizardStepNumber">
          <v-stepper-header>
            <v-stepper-step :complete="wizardStepNumber > 1" step="1">ACCOUNT</v-stepper-step>
            <v-stepper-step :complete="wizardStepNumber > 2" step="2">LOGO</v-stepper-step>
            <v-stepper-step :complete="wizardStepNumber > 3" step="3">USER</v-stepper-step>
            <v-stepper-step :complete="wizardStepNumber > 4" step="4">SUPPORT</v-stepper-step>
            <!-- <v-stepper-step :complete="wizardStepNumber > 5" step="5">COMPANY DETAILS</v-stepper-step> -->
            <v-stepper-step :complete="wizardStepNumber > 5" step="5">COMPANY</v-stepper-step>
            <v-stepper-step v-if="isDone" :complete="wizardStepNumber > 6" step="6">PAYMENT METHOD</v-stepper-step>

          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-layout row wrap>
                <v-flex style="padding: 10px;" md12>
                  <div class="signup-box">
                    <div style="gap:3rem" class="form-container">
                      <!-- <span style="font-size: 16px;font-weight: 600;text-transform: uppercase;">Get
                        started using Details</span> -->
                      <div style="display: flex;flex-direction: column;gap: 0.5rem;">
                        <span style="padding-left: 5px;"v-if="client_id" >Your <span  style="font-weight: 600;">details</span> will be available at <a style="color:#034575" href="javascript:void()">app.details.eu/{{client_id}}/</a></span>
                        <TextField :loading="loadingValidation" :id="'client_id'" :disabled="loadingValidation"
                          :validators="uniqueNameValidator" isModel  @blur="onClientIdChange" 
                          v-bind="textBlurFieldConfig" v-model="client_id" required showValidationIcons 
                          @validated="onValidation" :placeholder="$t('Account Name')">
                        </TextField>
                        <span style="color:red" v-if="errMessage">{{ errMessage }}</span>
                       
                        <Dropdown showValidationIcons required immediateValidation :id="'currency_code'" class="m2"
                          style="margin:3px;" @validated="(e) => onValidation('currency_code', e)"
                          :options="currenciesTV" :selected="currenciesTV.find((e) => e.value == currency_code)
                            " :placeholder="$t('Business Currency')" box @selectedChange="(e) => onCurrencyChange(e)">
                        </Dropdown>

                      </div>
               
                    </div>
                  </div>
                </v-flex>


              </v-layout>
            </v-stepper-content>
            <v-stepper-content step="2">

              <v-layout row wrap>
                <v-flex style="padding: 10px;" md12>
                  <div class="signup-box">
                    <div style="gap: 2rem;" class="form-container">
                      <span style="color:black;font-weight: 600; font-size: 16px">UPLOAD YOUR COMPANY LOGO
                        (optional)</span>
                      <div class="Neon Neon-theme-dragdropbox">
                        <template v-if="previewImage">
                          <div class="logo-box">

                            <img class="logo-image" :src="previewImage" />
                            <img @click="close" src="static/icons/close-icon-accent.svg"
                              class="dt-icon v5 close-button h1 s2" alt="Close" title="Close" />

                          </div>
                        </template>
                        <template v-if="!previewImage">
                          <input
                            style="z-index: 999; opacity: 0; width: 220px; height: 220px; position: absolute; right: 250px; left: 0px; margin-right: auto; margin-left: auto;"
                            type="file" accept="image/*" @change=uploadImage>
                          <div class="Neon-input-dragDrop">
                            <div class="Neon-input-inner">
                              <div class="Neon-input-icon"><i class="fa fa-file-image-o"></i></div>
                              <div class="Neon-input-text">
                                <h4>Drag &amp; Drop your logo here</h4> <span
                                  style="display:inline-block; margin: 15px 0">or</span>
                              </div><a class="Neon-input-choose-btn browse">Browse Files</a>
                            </div>

                          </div>
                        </template>

                      </div>
                      <span style="text-align: left;">
                        The logo needs to be a LIGHT color that contrasts with the dark default background, otherwise
                        it's
                        not visible. We ideally need a PNG with a transparent background in 300px X 120px.
                      </span>
           
                    </div>
                  </div>
                </v-flex>
                

              </v-layout>



            </v-stepper-content>


            <v-stepper-content step="3">
              <v-layout row wrap>
                <v-flex style="padding: 10px;" md8>
                  <div class="signup-box">
                    <div style="max-width: 750px;" class="form-container">
                      <div style="display: flex; justify-content: center;align-items: center;gap: 3rem;padding-bottom: 20px;">
                        <div style="display: flex;flex-direction: column;width: 50%;">
                          <template v-for="(user, index) in users">
                            <div style="display: flex;gap: 2rem;">
                              <div style="display: flex;justify-content: flex-start;align-items: center;"
                                class="checkbox-container">
                                <div class="dt-checkbox-control">
                                  <div class="dt-checkbox v2 s1">
                                    <input :checked="user.booking_flag"
                                      @click="e => onCheckboxChange(e, 'booking_flag', user)" type="checkbox"
                                      name="agree" :id="'agree'" />
                                    <div class="checkmark"></div>
                                  </div>

                                </div>
                                <div class="dt-checkbox-label">Booking Only</div>
                                <span style="padding-bottom: 6px;" title="A ‘booking-only’ user is allowed to access the following modules: Contacts, Booking, Accounting, and Settings." class="img-info">
            <img style="width: 20px;" src="static/icons/b2b/icon___information.svg" />
          </span>
                              </div>
                              <div style="display: flex; justify-content: flex-start;align-items: center;"
                                class="checkbox-container">
                                <div class="dt-checkbox-control">
                                  <div class="dt-checkbox v2 s1">
                                    <input :checked="user.yearly_paid"
                                      @click="e => onCheckboxChange(e, 'yearly_paid', user)" type="checkbox"
                                      name="agree" :id="'agree'" />
                                    <div class="checkmark"></div>
                                  </div>

                                </div>
                                <div class="dt-checkbox-label">Annual Payment</div>
                                <span style="padding-bottom: 6px;" title="Get an annual subscription and get 2 months for free" class="img-info">
            <img style="width: 20px;" src="static/icons/b2b/icon___information.svg" />
          </span>
                              </div>
                            </div>
              
                          <div class="field-content">
                            <TextField :id="'staff_email'" style="width: 100%" :validators="emailUserValidators"  @validated="onUserValidation" type="email" isModel required
                          showValidationIcons immediateValidation  @valuechanged="(name, value) => onUserTextFieldValueChange(name, value, user)" v-bind="textFieldConfig"
                          v-model="user.staff_email" :placeholder="$t('Email Address')">
                        </TextField>
                            <span style="visibility: hidden;"lass="input-group-text">
                                <img src="static/icons/eye.svg" v-if="!showEye"
                                  class="dt-icon v5 s2 fc2-hint nohover" />
                                <img src="static/icons/eye-slash.svg" v-if="showEye"
                                  class="dt-icon v5 s2 fc2-hint nohover" />
                              </span>
                          </div>
                          <div class="field-content">
                            <Dropdown style="width: 100%;margin: 5px 4px;"
          class="dt-dropdown" required showValidationIcons immediateValidation   @validated="(e) => onUserValidation('language', e)"
          :options="languagesTV"
          :selected="languagesTV.find(e => e.value == user.language)"
          box
          :placeholder="$t('Language')"
          v-on:selectedChange="e => onUserDropdownChange('language', e,user)"
          :listHeight="150"
        ></Dropdown>
                            <span style="visibility: hidden;"lass="input-group-text">
                                <img src="static/icons/eye.svg" v-if="!showEye"
                                  class="dt-icon v5 s2 fc2-hint nohover" />
                                <img src="static/icons/eye-slash.svg" v-if="showEye"
                                  class="dt-icon v5 s2 fc2-hint nohover" />
                              </span>
                          </div>
                            <div class="field-content">
                              <TextField :id="'password'" required :showValidationIcons="false" style="width: 100%"
                                v-bind="textFieldConfig" :value="user.password" :placeholder="'Password'" 
                                :password="showEye" @validated="onUserValidation"
                                @valuechanged="(name, value) => onUserTextFieldValueChange(name, value, user)">
                              </TextField>
                              <span @click="openEye" class="input-group-text">
                                <img src="static/icons/eye.svg" v-if="!showEye"
                                  class="dt-icon v5 s2 fc2-hint nohover" />
                                <img src="static/icons/eye-slash.svg" v-if="showEye"
                                  class="dt-icon v5 s2 fc2-hint nohover" />
                              </span>
                            </div>
                            <div class="field-content">
                              <TextField :id="'confirmedPassword'" :validators="confirmedPasswordValidator" required
                                :showValidationIcons="false" style="width: 100%" v-bind="textFieldConfig"
                                :value="user.confirmedPassword" :placeholder="'Confirm Password'"
                                :password="showConfirmEye" @validated="onUserValidation"
                                @valuechanged="(name, value) => onUserTextFieldValueChange(name, value, user)">
                              </TextField>
                              <span @click="openConfirmEye" class="input-group-text">
                                <img src="static/icons/eye.svg" v-if="!showConfirmEye"
                                  class="dt-icon v5 s2 fc2-hint nohover" />
                                <img src="static/icons/eye-slash.svg" v-if="showConfirmEye" style=""
                                  class="dt-icon v5 s2 fc2-hint nohover" />
                              </span>
                            </div>
                          </template>

                        </div>
                        <div>
                          <div class="pw_validation">
                            <span>Your password must contain the following:</span>
                            <ul id="warn_container">
                              <li>
                                <img v-if="!validationUserResult.letter.valid" class="invalid_circle"
                                  src="static/icons/b2b/invalid_30_30.svg" />
                                <img v-if="validationUserResult.letter.valid" class="valid_circle"
                                  src="static/icons/b2b/valid_30_30.svg" />
                                At least <strong>one letter</strong>
                              </li>
                              <li>
                                <img v-if="!validationUserResult.capital.valid" class="invalid_circle"
                                  src="static/icons/b2b/invalid_30_30.svg" />
                                <img v-if="validationUserResult.capital.valid" class="valid_circle"
                                  src="static/icons/b2b/valid_30_30.svg" />
                                At least <strong>one capital letter</strong>
                              </li>
                              <li>
                                <img v-if="!validationUserResult.number.valid" class="invalid_circle"
                                  src="static/icons/b2b/invalid_30_30.svg" />
                                <img v-if="validationUserResult.number.valid" class="valid_circle"
                                  src="static/icons/b2b/valid_30_30.svg" />
                                At least <strong>one number</strong>
                              </li>
                              <li>
                                <img v-if="!validationUserResult.space.valid" class="invalid_circle"
                                  src="static/icons/b2b/invalid_30_30.svg" />
                                <img v-if="validationUserResult.space.valid" class="valid_circle"
                                  src="static/icons/b2b/valid_30_30.svg" />
                                At least
                                <strong>one [~,!,@,#,$,%,^,&,*,-,_,=,.,;,:,']</strong>
                              </li>
                              <li id="length" class="wrong">
                                <img v-if="!validationUserResult.length.valid" class="invalid_circle"
                                  src="static/icons/b2b/invalid_30_30.svg" />
                                <img v-if="validationUserResult.length.valid" class="valid_circle"
                                  src="static/icons/b2b/valid_30_30.svg" />
                                At least <strong>8 characters</strong>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

              
                    </div>
                  </div>
                </v-flex>
                <v-flex md4 style="padding: 10px;">
                  <div class="summary-container">

                    <h4 style="font-weight: bold;padding-bottom: 32px;">Summary</h4>
                    
                    <div>
                      <h4 style="font-weight: bold;padding-bottom: 5px;">Usage Fees</h4>
                      <div v-if="!users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                        <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                          <span style="font-weight: 600;"> Re-occuring monthly user fee is {{ usage_fees.all_modules }} EUR</span>
                        </div>
                        <div style="min-width: 45px" class="value">{{ prorated_usage_fees.all_modules }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (1 year: {{ getMonth() }} - {{ getYear()
                          }})</span>
                       <!-- <span>Monthly: {{ usage_fees.all_modules }} EUR</span> -->
                        </div>
                        <div style="min-width:45px;" class="value">{{ yearly_usage_fees.all_modules  }} EUR</div>

                      </div>
                      <div v-if="users[0].booking_flag && !users[0].yearly_paid" class="value-container">
                        
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (booking Only, {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                          <span style="font-weight: 600;"> Re-occuring monthly user fee is {{ usage_fees.booking_module }} EUR</span>


                          
                        </div>
                        <div style="min-width: 45px" class="value">{{ prorated_usage_fees.booking_module }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( booking Only, 1 Year: {{ getMonth() }}
                          - {{
                            getYear() }})</span>
                         <!-- <span>Monthly: {{ usage_fees.booking_module }} EUR</span> -->
                        </div>
                        <div style="min-width: 45px" class="value">{{ yearly_usage_fees.booking_module  }} EUR</div>

                      </div>
                      <div style="border-top: 1px solid rgb(179, 178, 178);font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Usage Fees
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getTotal() }} EUR</div>

                      </div>
                      <div style="padding-top:10px;font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Billing for Sign Up
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getTotal() }} EUR</div>

                      </div>
                    </div>


                  </div>
                </v-flex>

              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-layout row wrap>
                <v-flex style="padding: 10px;" md8>
                  <div class="signup-box">
                    <div style="max-width:500px" class="form-container">
                      <div class="support-package">
                        <form>
                          <template v-for="(summaryPackages, key) in supportPackages">
                            <!-- <fieldset>
                              <legend>{{ summaryPackages.name }}</legend> -->

                              <template v-for="pData in summaryPackages.packages">
                               <div :class="{'not-support':summaryPackages.name.toLowerCase() == 'no support'}" class="package-content">
                                <div>
                                  <input type="radio" :checked="pData.id == selectedID"
                                  @change="(e) => onRadioChange(pData)" :name="pData.id" />
                                <label style="font-weight: 600;text-transform:uppercase ;padding-left:5px" :for="pData.id">{{ pData.name }}</label>
                                <div style="display: flex;flex-direction: column;padding-left: 30px;">
                                  <span v-for="item in pData.items">
                                    <template v-if="summaryPackages.name.toLowerCase() != 'no support'">
                                      <img  style="width:5px;height: 5px"
                                      src="static/icons/arrows/circle.svg" /> &nbsp; {{ item }}
                                    </template>
                                    <template v-else>
                                     {{ item }}
                                    </template>
                                    
                                  </span>
                                </div>
                                <div  v-if="summaryPackages.name.toLowerCase() != 'no support'"
                                  style="display: flex;flex-direction: column;padding-left: 30px;padding-top:10px">
                                  <span>Total: {{ pData.time }} hours @ {{ pData.rate }}€ = {{ pData.time * pData.rate
                                    }}€
                                  </span>
                                  <span style="font-weight: bold">One time only sign up Price {{ pData.one_time_bill }}€</span>
                                </div>
                                </div>
                                <div v-if="summaryPackages.name.toLowerCase() != 'no support'" >
                                  <div v-if="pData.discount" style="background: #FF6400;
  border: 1px solid hsla(0,0%,78.4%,.5019607843);
  border-radius: 5px;
  padding: 4px;margin-top: 5px;
  color: white;min-width: 70px;text-align: center;"> <span >Save {{pData.discount}}%</span>
                                    
                                  </div>
                                  <div v-if="pData.best_deal" style="
  border: 1px solid #FF6400;
  border-radius: 5px;
  padding:2px 4px;margin-top: 5px;color:#FF6400;min-width: 70px;text-align: center;"> <span >Best Deal</span>
                                    
                                  </div>
                                 
                                </div>
                               </div>
                                


                              </template>


                            <!-- </fieldset> -->
                          </template>

                        </form>
                      </div>
                     
              
                    </div>
                  </div>
                </v-flex>
                <v-flex md4 style="padding: 10px;">
                  <div class="summary-container">

                    <h4 style="font-weight: bold;padding-bottom: 32px;">Summary</h4>
                    <div v-if="summaryPackages && summaryPackages.length > 0">
                      <h4 style="font-weight: bold;padding-bottom: 5px;">Subscription Fees (one time only)</h4>

                      <div v-for="pData in summaryPackages" class="value-container">
                        <div class="label">
                          {{ pData.name }}
                        </div>
                        <div style="min-width:50px;" class="value">{{pData.value>0? `${pData.value} EUR`:'' }}</div>

                      </div>
                      <div style="border-top: 1px solid rgb(179, 178, 178);font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Subscription Fees
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getSubscriptionTotal() }} EUR</div>

                      </div>

                    </div>
                    <div>
                      <h4 :style="{'paddingTop':summaryPackages && summaryPackages.length > 0? '32px':''}" style="font-weight: bold;padding-bottom: 5px;">Usage Fees</h4>
                      <div v-if="!users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                        <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                          <span style="font-weight: 600;"> Re-occuring monthly user fee is {{ usage_fees.all_modules }} EUR</span>
                        </div>
                        <div style="min-width: 45px" class="value">{{ prorated_usage_fees.all_modules }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (1 year: {{ getMonth() }} - {{ getYear()
                          }})</span>
                       <!-- <span>Monthly: {{ usage_fees.all_modules }} EUR</span> -->
                        </div>
                        <div style="min-width: 45px" class="value">{{ yearly_usage_fees.all_modules  }} EUR</div>

                      </div>
                      <div v-if="users[0].booking_flag && !users[0].yearly_paid" class="value-container">
                        
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (booking Only, {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                          <span style="font-weight: 600;"> Re-occuring monthly user fee is {{ usage_fees.booking_module }} EUR</span>


                          
                        </div>
                        <div style="min-width: 45px" class="value">{{ prorated_usage_fees.booking_module }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( booking Only, 1 Year: {{ getMonth() }}
                          - {{
                            getYear() }})</span>
                         <!-- <span>Monthly: {{ usage_fees.booking_module }} EUR</span> -->
                        </div>
                        <div style="min-width: 45px" class="value">{{ yearly_usage_fees.booking_module  }} EUR</div>

                      </div>
                      <div style="border-top: 1px solid rgb(179, 178, 178);font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Usage Fees
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getTotal() }} EUR</div>

                      </div>
                      <div style="padding-top:10px;font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Billing for Sign Up
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getNetTotal() }} EUR</div>

                      </div>
                    </div>


                  </div>
                </v-flex>

              </v-layout>
            </v-stepper-content>
            <!-- <v-stepper-content step="5">
              <v-layout row wrap>
                <v-flex style="padding: 10px;" md8>
                  <div class="signup-box">
                    <div style="gap:2rem" class="form-container">
                      <div style="display:flex;flex-direction: column;gap: .5rem;">
                        <TextField :id="'client_name'" @validated="onCompanyDetailsValidation" required
                          showValidationIcons immediateValidation @valuechanged="onTextFieldValueChange"
                          v-bind="textFieldConfig" v-model="client_name" :placeholder="$t('Company Name')">
                        </TextField>
                        <TextField :id="'client_admin'" :validators="emailValidators"  @validated="onCompanyDetailsValidation" type="email" isModel required
                          showValidationIcons immediateValidation @valuechanged="onEmailChange" v-bind="textFieldConfig"
                          v-model="client_admin" :placeholder="$t('Mail Address')">
                        </TextField>

                      </div>
                      <div class="options">
                        <button
                          style="border: none;max-width: fit-content;min-width: fit-content;text-decoration: underline;"
                          class="dt-button s6 btn-back" @click.stop="wizardStepNumber--">
                          {{ $dft.snakeCaseToWords("back") }}
                        </button>
                        <button style="max-width: 100px;min-width: 100px;"
                          :class="{ disabled: loadingEmail || !isCompanyDetailsFormValid }"
                          :disabled="loadingEmail || !isCompanyDetailsFormValid" class="dt-button s6"
                          @click.stop="wizardStepNumber++">
                          {{ $dft.snakeCaseToWords("Next") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex md4 style="padding: 10px;">
                  <div class="summary-container">

                    <h4 style="font-weight: bold;padding-bottom: 30px;">Summary</h4>
                    <div v-if="summaryPackages && summaryPackages.length > 0">
                      <h4 style="font-weight: bold;padding-bottom: 5px;">Subscription Fees (one time only)</h4>
                      <div v-for="pData in summaryPackages" class="value-container">
                        <div class="label">
                          {{ pData.name }}
                        </div>
                        <div class="value">{{pData.value>0? `${pData.value} EUR`:'' }}</div>

                      </div>
                      <div style="border-top: 1px solid rgb(179, 178, 178);font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Subscription Fees
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getSubscriptionTotal() }} EUR</div>

                      </div>
                    </div>
                    <div style="padding-top: 20px;">
                      <h4 style="font-weight: bold;padding-bottom: 5px;">Usage Fees (re-occuring)</h4>
                      <div v-if="!users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;" class="label">
                        <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                            <span> Monthly: <span style="font-weight: 600;">{{ usage_fees.all_modules }}</span>EUR</span>
                        </div>
                        <div class="value">{{ prorated_usage_fees.all_modules }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (1 year: {{ getMonth() }} - {{ getYear()
                          }})</span>
                     
                        </div>
                        <div class="value">{{ yearly_usage_fees.all_modules  }} EUR</div>

                      </div>
                      <div v-if="users[0].booking_flag && !users[0].yearly_paid" class="value-container">
                        
                        <div style="display: flex;flex-direction: column;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (booking Only, {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                            <span> Monthly: <span style="font-weight: 600;">{{ usage_fees.booking_module }} </span>EUR</span>


                          
                        </div>
                        <div class="value">{{ prorated_usage_fees.booking_module }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;" class="label">
                          <span>User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( booking Only, 1 Year: {{ getMonth() }}
                          - {{
                            getYear() }})</span>
                        
                        </div>
                        <div class="value">{{ yearly_usage_fees.booking_module  }} EUR</div>

                      </div>
                      <div style="border-top: 1px solid rgb(179, 178, 178);font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Usage Fees
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getTotal() }} EUR</div>

                      </div>
                      <div style="padding-top:10px;font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Billing for Sign Up
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getNetTotal() }} EUR</div>

                      </div>
                    </div>


                  </div>
                </v-flex>

              </v-layout>
            </v-stepper-content> -->

            <v-stepper-content step="5">
              <v-layout row wrap>
                <v-flex style="padding: 10px;" md8>
                  <div class="signup-box">
                    <div style="max-width: 500px;" class="form-container">
                      
                      <div style="display:flex;flex-direction: column;gap: .5rem;">
                        <TextField :id="'client_name'" @validated="onInvoiceValidation" required
                          showValidationIcons immediateValidation @valuechanged="onTextFieldValueChange"
                          v-bind="textFieldConfig" v-model="client_name" :placeholder="$t('Company Name')">
                        </TextField>
                        <TextField :id="'client_admin'" :validators="emailValidators"  @validated="onInvoiceValidation" type="email" isModel required
                          showValidationIcons immediateValidation @valuechanged="onEmailChange" v-bind="textFieldConfig"
                          v-model="client_admin" :placeholder="$t('Email Address')">
                        </TextField>
                        
                        <TextField required showValidationIcons immediateValidation
                          @valuechanged="onTextFieldValueChange" @validated="onInvoiceValidation" :id="'client_address'"
                          v-bind="textFieldConfig" v-model="client_address" :placeholder="$t('Street Address')">
                        </TextField>
                        <div style="display: flex;width: 100%;gap: 2rem;">
                          <TextField required showValidationIcons immediateValidation
                            @valuechanged="onTextFieldValueChange" @validated="onInvoiceValidation" :id="'postal_code'"
                            style="width:40%" v-bind="textFieldConfig" v-model="postal_code"
                            :placeholder="$t('Postal Code')">
                          </TextField>
                          <TextField required showValidationIcons immediateValidation @blur="onCityBlur"
                            :loading="loadingCity" @validated="onInvoiceValidation" :id="'city'" style="width:100%"
                            v-bind="textBlurFieldConfig" v-model="city" :placeholder="$t('City')">
                          </TextField>
                        </div>
                        <!-- <TextField required showValidationIcons immediateValidation
                          @valuechanged="onTextFieldValueChange" @validated="onInvoiceValidation" :id="'country'"
                          v-bind="textFieldConfig" v-model="country" :placeholder="$t('Country')">
                        </TextField> -->
                        <Dropdown style="width: 98.5%;margin: 0 4px;":disabled="loadingCity" required showValidationIcons immediateValidation   @validated="(e) => onInvoiceValidation('country', e)"  :options="countries || []" :selected="(countries || []).find((c) => c.value == country)
                          " class="m2" :placeholder="'Country'" v-on:selectedChange="(e) => onCountryChange(e)"
                          :listHeight="128" box></Dropdown>
                          <template v-if="isEu" >
                          <TextField  :id="'vatID'" required v-bind="textBlurFieldConfig" v-model="vatID" @validated="onInvoiceValidation"
                          :validators="uniqueVATIDValidator" showValidationIcons  immediateValidation  :disabled="loadingVatId"
                          :loading="loadingVatId"   @blur="onVatTextFieldValueChange"
                          :placeholder="$t('Vat ID( EU clients)')">
                        </TextField>
                        </template>
                         <tempalte v-else>
                          <TextField  :id="'vatID'" v-bind="textBlurFieldConfig" v-model="vatID" @validated="onInvoiceValidation"
                          :validators="uniqueVATIDValidator" showValidationIcons  immediateValidation  :disabled="loadingVatId"
                          :loading="loadingVatId"   @blur="onVatTextFieldValueChange"
                          :placeholder="$t('Vat ID( EU clients)')">
                        </TextField>
                         </tempalte>
                        
                          
                      </div>
                
                    </div>
                  </div>
                </v-flex>
                <v-flex md4 style="padding: 10px;">
                  <div class="summary-container">

                    <h4 style="font-weight: bold;padding-bottom: 32px;">Summary</h4>
                    <div v-if="summaryPackages && summaryPackages.length > 0">
                      <h4 style="font-weight: bold;padding-bottom: 5px;">Subscription Fees (one time only)</h4>
                      <div v-for="pData in summaryPackages" class="value-container">
                        <div class="label">
                          {{ pData.name }}
                        </div>
                        <div style="min-width:50px;" class="value">{{pData.value>0? `${pData.value} EUR`:'' }}</div>

                      </div>
                      <div style="border-top: 1px solid rgb(179, 178, 178);font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Subscription Fees
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getSubscriptionTotal() }} EUR</div>

                      </div>

                    </div>
                    <div>
                      <h4 :style="{'paddingTop':summaryPackages && summaryPackages.length > 0? '32px':''}" style="font-weight: bold;padding-bottom: 5px;">Usage Fees</h4>
                      <div v-if="!users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                        <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                          <span style="font-weight: 600;"> Re-occuring monthly user fee is {{ usage_fees.all_modules }} EUR</span>
                        </div>
                        <div style="min-width: 45px" class="value">{{ prorated_usage_fees.all_modules }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (1 year: {{ getMonth() }} - {{ getYear()
                          }})</span>
                       <!-- <span>Monthly: {{ usage_fees.all_modules }} EUR</span> -->
                        </div>
                        <div style="min-width: 45px" class="value">{{ yearly_usage_fees.all_modules  }} EUR</div>

                      </div>
                      <div v-if="users[0].booking_flag && !users[0].yearly_paid" class="value-container">
                        
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (booking Only, {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                          <span style="font-weight: 600;"> Re-occuring monthly user fee is {{ usage_fees.booking_module }} EUR</span>


                          
                        </div>
                        <div style="min-width: 45px" class="value">{{ prorated_usage_fees.booking_module }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( booking Only, 1 Year: {{ getMonth() }}
                          - {{
                            getYear() }})</span>
                         <!-- <span>Monthly: {{ usage_fees.booking_module }} EUR</span> -->
                        </div>
                        <div class="value">{{ yearly_usage_fees.booking_module  }} EUR</div>

                      </div>
                      <div style="border-top: 1px solid rgb(179, 178, 178);font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Usage Fees
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getTotal() }} EUR</div>

                      </div>
                      <div style="padding-top:10px;font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Billing for Sign Up
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getNetTotal() }} EUR</div>

                      </div>
                    </div>

                    <div class="button-options">
                      <div  class="checkbox-container">
                        <div class="dt-checkbox-control">
                          <div class="dt-checkbox v2 s1">
                            <input :checked="is_agree" @click="e => onSetupCheckboxChange(e, 'is_agree')"
                              type="checkbox" name="agree" :id="'agree'" />
                            <div class="checkmark"></div>
                          </div>
                          
                            <div class="dt-checkbox-label">I agree with the <a target="_blank" style="color:#034575;font-weight: 600;font-size: 16px;" href='https://www.details.eu/terms/'>Terms of use.</a></div>
                          
                        
                        </div>
                      </div>
                      
                      <button @click="onSave" class="dt-button btn-signup v1 s1"
                        :class="{ disabled: !is_agree || loading || !isInvoiceFormValid }"
                        :disabled="!is_agree || loading || !isInvoiceFormValid">
                        Sign Up
                      </button>
                    </div>
                  </div>
                </v-flex>

              </v-layout>
            </v-stepper-content>

            <v-stepper-content  step="6">
              <v-layout v-if="isDone" row wrap>
                <v-flex style="padding: 10px;" md8>
                  <div class="signup-box">
                    <div class="form-container">
                      <div style="display: flex;flex-direction: column;gap: 1rem;">
                        <div style="display: flex;gap: 0.5rem;" class="radio-item">
                          <input type="radio" @change="(e) => onPaymentRadioChange('card')" :checked="showCard"
                            name="product" />
                          <label style="display: flex;align-items: center;gap:1rem"for="product">
                            <span>Pay with Card (Mastercard, Amex or Visa)</span>

                           <div style="display: flex;justify-content: center;gap: 1.5rem;"> <img class="dt-icon" style="height: 28px;"  src="static/icons/mastercard.svg" alt="" />
                            <img class="dt-icon" src="static/icons/amex.svg" style="height: 28px;" alt="" />
                            <img class="dt-icon"  src="static/icons/visa.svg" style="height: 28px;" alt="" /></div>
                          </label>
                        </div>
                        <div style="display: flex;gap: 0.5rem;" class="radio-item">
                          <!-- <input type="radio" @change="(e) => onPaymentRadioChange('sepa')" :checked="showSepadirectdebit"
                            name="product" /> -->
                          <label style="display: flex;align-items: center;"for="product">
                            <span> <a @click="emailLink" style="color:#034575;font-weight: 600;font-size: 14px;" class="link-text"> Contact us </a>if you want to Pay with Sepa</span>

                            <img class="dt-icon" style="height:36px;padding-left: 12px;" src="static/icons/sepa.svg" alt="" />
                          </label>
                        </div>
                        <div
          v-show="errPaymentMessage"
          style="padding: 15px 20px"
          id="resultPaymentFail"
        >
          {{ errPaymentMessage }}
        </div>
                        <div
            id="card_box"
            class="payment_type_box"
            style="padding: 20px"
            v-if="showCard"
          >
            <div id="card" class="payment"></div>
          </div>
          <div
            v-if="showSepadirectdebit"
            id="sepadirectdebit_box"
            class="payment_type_box"
            style="padding: 20px"
          >
            <div id="sepadirectdebit" class="payment"></div>
          </div>
                      </div>
                      <!-- <div class="options">
                        <button
                          style="border: none;max-width: fit-content;min-width: fit-content;text-decoration: underline;"
                          class="dt-button s6" @click.stop="wizardStepNumber--">
                          {{ $dft.snakeCaseToWords("back") }}
                        </button>
                      
                      </div> -->
                    </div>
                  </div>
                </v-flex>
                <v-flex md4 style="padding: 10px;">
                  <div class="summary-container">

<h4 style="font-weight: bold;padding-bottom: 32px;">Summary</h4>
<div v-if="summaryPackages && summaryPackages.length > 0">
  <h4 style="font-weight: bold;padding-bottom: 5px;">Subscription Fees (one time only)</h4>
  <div v-for="pData in summaryPackages" class="value-container">
    <div class="label">
      {{ pData.name }}
    </div>
    <div style="min-width:45px;" class="value">{{pData.value>0? `${pData.value} EUR`:'' }}</div>

  </div>
  <div style="border-top: 1px solid rgb(179, 178, 178);font-weight: bold;" class="value-container">
    <div class="label">
      Total Subscription Fees
    </div>
    <div style="font-weight: bold;" class="value">{{ getSubscriptionTotal() }} EUR</div>

  </div>
</div>
<div>
                      <h4 :style="{'paddingTop':summaryPackages && summaryPackages.length > 0? '32px':''}" style="font-weight: bold;padding-bottom: 5px;">Usage Fees</h4>
                      <div v-if="!users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                        <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                          <span style="font-weight: 600;"> Re-occuring monthly user fee is {{ usage_fees.all_modules }} EUR</span>
                        </div>
                        <div style="min-width: 45px" class="value">{{ prorated_usage_fees.all_modules }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && !users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (1 year: {{ getMonth() }} - {{ getYear()
                          }})</span>
                       <!-- <span>Monthly: {{ usage_fees.all_modules }} EUR</span> -->
                        </div>
                        <div style="min-width: 45px" class="value">{{ yearly_usage_fees.all_modules  }} EUR</div>

                      </div>
                      <div v-if="users[0].booking_flag && !users[0].yearly_paid" class="value-container">
                        
                        <div style="display: flex;flex-direction: column;width: 80%;" class="label">
                          <span>  User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> (booking Only, {{ getMonth() }})</span>
                          <span>Prorated: {{getMonthDaysLeft()  }} Days of {{daysInThisMonth()  }} Days</span>
                          <span style="font-weight: 600;"> Re-occuring monthly user fee is {{ usage_fees.booking_module }} EUR</span>


                          
                        </div>
                        <div style="min-width: 45px" class="value">{{ prorated_usage_fees.booking_module }} EUR</div>

                      </div>
                      <div v-if="users[0].yearly_paid && users[0].booking_flag" class="value-container">
                        <div style="display: flex;flex-direction: column;" class="label">
                          <span>User <span style="font-weight: 600;">{{ users.length > 0 ? users[0].user_name : '' }}</span> ( booking Only, 1 Year: {{ getMonth() }}
                          - {{
                            getYear() }})</span>
                         <!-- <span>Monthly: {{ usage_fees.booking_module }} EUR</span> -->
                        </div>
                        <div class="value">{{ yearly_usage_fees.booking_module  }} EUR</div>

                      </div>
                      <div style="border-top: 1px solid rgb(179, 178, 178);font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Usage Fees
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getTotal() }} EUR</div>

                      </div>
                      <div style="padding-top:10px;font-weight: bold;" class="value-container">
                        <div class="label">
                          Total Billing for Sign Up
                        </div>
                        <div style="font-weight: bold;" class="value">{{ getNetTotal() }} EUR</div>

                      </div>
                    </div>


</div>
                </v-flex>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
                      <div  v-if="wizardStepNumber==1" class="options">
                        <button
                          style="border: none;max-width: fit-content;min-width: fit-content;text-decoration: underline; visibility: hidden"
                          class="dt-button s6" >
                          {{ $dft.snakeCaseToWords("back") }}
                        </button>
                        <button :class="{ disabled: loadingValidation || !isFormValid }"
                          :disabled="loadingValidation || !isFormValid" style="min-width: 100px;max-width: 100px"
                          class="dt-button s6" @click.stop="wizardStepNumber++">
                          <span>Next</span>

                        </button>
                      </div>
                      <div class="options" v-if="wizardStepNumber==2">
                        <button
                          style="border: none;max-width: fit-content;min-width: fit-content;text-decoration: underline;"
                          class="dt-button s6" @click.stop="wizardStepNumber--">
                          {{ $dft.snakeCaseToWords("back") }}
                        </button>
                        <button style="max-width: 100px;min-width: 100px;" class="dt-button s6"
                          @click.stop="wizardStepNumber++">
                          {{ $dft.snakeCaseToWords("Next") }}
                        </button>

                      </div>
                      <div class="options" v-if="wizardStepNumber==3">
                        <button
                          style="border: none;max-width: fit-content;min-width: fit-content;text-decoration: underline;"
                          class="dt-button s6 btn-back" @click.stop="wizardStepNumber--">
                          {{ $dft.snakeCaseToWords("back") }}
                        </button>
                        <button :class="{ disabled: !isUserFormValid }" :disabled="!isUserFormValid"
                          style="max-width: 100px;min-width: 100px;" class="dt-button s6"
                          @click.stop="wizardStepNumber++">
                          {{ $dft.snakeCaseToWords("Next") }}
                        </button>
                      </div>
                      <div class="options" v-if="wizardStepNumber==4">
                        <button style="border: none;max-width: fit-content; min-width: fit-content;text-decoration: underline;" class="dt-button s6" @click.stop="wizardStepNumber--">
                          {{ $dft.snakeCaseToWords("back") }}
                        </button>
                        <button style="max-width: 100px; min-width: 100px;"  :class="{ disabled: !selectedID }"
                          :disabled="!selectedID" class="dt-button s6" @click.stop="wizardStepNumber++">
                          {{ $dft.snakeCaseToWords("Next") }}
                        </button>
                      </div>
                       <div v-if="wizardStepNumber==5" class="options">
                        <button 
                          style="border: none;max-width: fit-content;min-width: fit-content;text-decoration: underline;"
                          class="dt-button s6" @click.stop="wizardStepNumber--">
                          {{ $dft.snakeCaseToWords("back") }}
                        </button>
                        <button
                          style="max-width: 100px; min-width: 100px; visibility: hidden"
                          class="dt-button s6" >
                          {{ $dft.snakeCaseToWords("Next") }}
                        </button>
                      </div>
                      <!-- <div class="options" v-if="wizardStepNumber==6">
                        <button
                          style="border: none;max-width: fit-content;min-width: fit-content;text-decoration: underline;"
                          class="dt-button s6" @click.stop="wizardStepNumber--">
                          {{ $dft.snakeCaseToWords("back") }}
                        </button>
                        <button
                          style="max-width: 100px; min-width: 100px; visibility: hidden"
                          class="dt-button s6" >
                          {{ $dft.snakeCaseToWords("Next") }}
                        </button>
                      
                      </div> -->
        </v-stepper>
      </div>
    </div>

  </div>
</template>
<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-GW3P6ZD7RW"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-GW3P6ZD7RW');
  import "@adyen/adyen-web/dist/adyen.css";
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";
import { SignupService } from "../services/signup.service";
import { createTV } from "../models/text-value.model";
import { createValidator } from "@plugins/text-field";
import { subscribeSubject, uuidv4,sendMailHref} from "../utility";
import { Subject } from "rxjs";
import { createCountriesTV } from "../models/country.model";
import { HttpClient } from "../services/http/signup-http-client";
import {
  createTextFieldConfig,
  EventHooks,
} from "../plugins/text-field";
import {
  NotificationService,
} from "../dt-plugins/notification/notification.service";
import { createLanguageTV } from '../models/language.model';
const validateEmail = (email) => {
  return email && String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
export default {
  components: {
    TextField,
    Dropdown
  },
  data: function () {
    return {
      client_id: '',
      currency_code: "",
      client_name: "",
      client_admin: "",
      label: "",
      booking: "",
      client_address: "",
      postal_code: "",
      city: "",
      country: "",
      vatID: "",
      checksum: "",
      client_logo: "",
      support_packages: [],
      users: [
        {
          language:"",
          staff_email:'',
          booking_flag: 0,
          yearly_paid: 0,
          id: 1,
          password: "",
          confirmedPassword: ""
        }
      ],
      countries: [],
      is_agree: false,
      wizardStepNumber: 1,
      isEu:false,
      validationResult: {
        // length: {
        //   valid: false,
        //   errors: ["error"],
        // },
        // letter: {
        //   valid: false,
        //   errors: ["error"],
        // },
      },
      validationCompanyDetailsResult: {},
      validationUserResult: {
        capital: {
          valid: false,
          errors: ["error"],
        },
        letter: {
          valid: false,
          errors: ["error"],
        },
        number: {
          valid: false,
          errors: ["error"],
        },
        length: {
          valid: false,
          errors: ["error"],
        },
        space: {
          valid: false,
          errors: ["error"],
        },
      },
      validationInvoiceResult: {},
      clientSubject: new Subject(),
      emailNameSubject: new Subject(),
      vatIdSubject: new Subject(),
      duplicateClientId: "",
      duplicateEmail: '',
      duplicateVatID: '',
      errMessage: null,
      loadingCity: false,
      errEmailMessage: null,
      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        immediateValidation: false,
      }),
      textBlurFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      }),
      companyDetails: null,
      initialData: null,
      loading: false,
      loadingValidation: false,
      loadingVatId: false,
      loadingEmail: false,
      vat_handling: null,
      previewImage: null,
      is_edit: false,
      selectedID: null,
      summaryPackages: [],
      imageHeight: 0,
      usage_fees: {
        all_modules: 0,
        booking_module: 0
      },
      prorated_usage_fees:{
        all_modules: 0,
        booking_module: 0
      },
      yearly_usage_fees:{
        all_modules: 0,
        booking_module: 0
      },
      showEye: true,
      showConfirmEye: true,
      isDone:false,
      showCard:false,
      showSepadirectdebit:false,
      adyen_server_type:'',
      client_key:'',
      amount:'',
      type: "card",
      errPaymentMessage: "",
      payment_method: "",
      isClientValid:false,
      languages:[],
      step:1,
    };
  },
  mounted: async function () {
    console.log('HttpClient.baseUrl',HttpClient.baseUrl);

    this.initialData = await SignupService.initialLoad();
    this.usage_fees = this.initialData?.monthly_usage_fees;
    this.prorated_usage_fees = this.initialData?.prorated_usage_fees;
    this.yearly_usage_fees = this.initialData?.yearly_usage_fees
    this.languages=this.initialData?.languages
    const support_packages = this.sortObject(this.initialData?.support_packages);
    Object.values(support_packages).forEach((p, index) => {
      if (index == 0) {
        this.support_packages.push({
          name: 'Support Packages for BOOKING',
          packages: p.map(pk => {
            pk.id = uuidv4()
            return pk;
          })
        })
      };
      if (index == 1) {
        this.support_packages.push({
          name: 'Support Packages for LABEL',
          packages: p.map(pk => {
            pk.id = uuidv4()
            return pk;
          })
        })
      }
      if (index == 2) {
        this.support_packages.push({
          name: 'NO SUPPORT',
          packages: p.map(pk => {
            pk.id = uuidv4()
            return pk;
          })
        })
      }

    })
    if (this.initialData && this.initialData.currencies.length > 0) {
      this.currency_code = this.initialData.currencies.find(c=>c.code=='EUR').value||0;
    }
    subscribeSubject(this, this.vatIdSubject, async (value) => {
      this.loadingVatId = true;
      try {
        const valid = await SignupService.isValidVatId(
          {
            vatID: value,
            country: this.country
          }
        );
        console.log('valid', valid)
        this.loadingVatId = false;
        if (!valid) {
          this.vatID = null;
          this.duplicateVatID = value;
          this.$nextTick(() => {
            this.vatID = value;
          });
          this.errVatMessage = valid == 0 ? 'Vat ID is not valid!!' : 'Vat ID is not among EU countries!!';
        }
      }
      catch (err) {

      }


    });
    subscribeSubject(this, this.emailNameSubject, async (value) => {
      this.loadingEmail = true;
      try {
        const checkUnique = await SignupService.clientEmailValidation(
          value
        );
        const is_email_taken = checkUnique.is_valid;
        this.loadingEmail = false;
        if (!is_email_taken) {
          this.duplicateEmail = value
          this.client_admin = null;
          this.$nextTick(() => {
            this.client_admin = value;
          });
          this.errEmailMessage = checkUnique.error;
        }
      }
      catch (err) {

      }


    });
    subscribeSubject(this, this.clientSubject, async (value) => {
      this.loadingValidation = true;
      try {
        const checkUnique = await SignupService.clientIdValidation(
          value
        );
        const is_unique = checkUnique.is_valid;
        this.checksum = checkUnique.checksum;
        this.loadingValidation = false;
        if (!is_unique) {
          this.duplicateClientId = value;
          const temp = this.client_id;
          this.client_id = null;
          this.$nextTick(() => {
            this.client_id = temp;
          });
          this.errMessage = checkUnique.error;
        }
      }
      catch (err) {

      }


    });
    
    this.paymentCheck();
    this.resumePayment();
   
    
    
  },
  mixins: [],

  computed: {

    resultCode:function(){
     return this.$route.query.resultCode
    },
    resumingpayment:function(){
     return this.$route.query.resumingpayment
    },
    languagesTV: function() {
      return createLanguageTV(this.languages);
    },
    supportPackages: function () {
      return this.users[0].booking_flag > 0 ? this.support_packages && this.support_packages.filter(p => p.name !== 'Support Packages for LABEL') : this.support_packages && this.support_packages.filter(p => p.name !== 'Support Packages for BOOKING')
    },
    paddingTop: function () {
      return `${120 - this.imageHeight}px`
    },
    confirmedPasswordValidator() {
      return [
        createValidator({
          name: "confirmedPassword",
          validatorFn: this.checkConfirmPassword,
          errorMessage: "Client Id is already exist",
        }),
      ];
    },
    passwordValidator() {
      return [
        createValidator({
          name: "confirmedPassword",
          validatorFn: this.checkPassword,
          errorMessage: "Client Id is already exist",
        }),
      ];
    },
    userNameValidator() {
      return [
        createValidator({
          name: "uniqName",
          validatorFn: this.checkUserName,
          errorMessage: "Client Id is already exist",
        }),
      ];
    },
    uniqueNameValidator() {
      return [
      // createValidator({
      //     name: "validateLengthClientID",
      //     validatorFn: this.validateLengthClient,
      //     errorMessage: "Client Id is already exist",
      //   }),
        createValidator({
          name: "validateClientID",
          validatorFn: this.validateClient,
          errorMessage: "Client Id is already exist",
        }),
        createValidator({
          name: "uniqName",
          validatorFn: this.checkUniq,
          errorMessage: "Client Id is already exist",
        }),
      ];
    },
    uniqueVATIDValidator() {
      return [
      // createValidator({
      //     name: "VatIDRequiredValidation",
      //     validatorFn: this.isRequired,
      //     errorMessage: "Must be a valid Email",
      //   }),
        createValidator({
          name: "VatIDValidation",
          validatorFn: this.checkVatID,
          errorMessage: "Client Id is already exist",
        }),
      ];
    },
    emailUserValidators() {
      return [
        createValidator({
          name: "emailValidation",
          validatorFn: validateEmail,
          errorMessage: "Must be a valid Email",
        }),
        // createValidator({
        //   name: "uniqEmail",
        //   validatorFn: this.checkEmailUniq,
        //   errorMessage: "Email is already exist",
        // }),
      ];
    },
    emailValidators() {
      return [
        createValidator({
          name: "emailValidation",
          validatorFn: validateEmail,
          errorMessage: "Must be a valid Email",
        }),
        // createValidator({
        //   name: "uniqEmail",
        //   validatorFn: this.checkEmailUniq,
        //   errorMessage: "Email is already exist",
        // }),
      ];
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },


    isCompanyDetailsFormValid: function () {
      return Object.values(this.validationCompanyDetailsResult).every((e) => e.valid);
    },
    isUserFormValid: function () {
      return this.users.filter(u => u.staff_email && u.staff_email != '').length == this.users.length && Object.values(this.validationUserResult).every((e) => e.valid);
    },
    isInvoiceFormValid: function () {
      return Object.values(this.validationInvoiceResult).every((e) => e.valid);
    },
    currenciesTV: function () {
      return createTV(
        this.initialData?.currencies || [],
        "label",
        "value"
      );
    }
  },
  methods: {
    emailLink: function () {
      this.hideAllPaymentTypeBoxes();
      const body = "";
      const subject = `[${this.client_id}] I would like to pay with SEPA`;
      const mails = ["contact@details.eu"];
      sendMailHref({ subject, body, mails });
    },
    resumePayment(){
      if(this.resumingpayment=='sepa_payment'){
      this.wizardStepNumber=6;
      this.isDone=true;
      this.client_id=this.$route.query.client_id;
      this.checksum=this.$route.query.checksum;
      SignupService.getPaymentFormData({client_id:this.client_id,checksum:this.checksum}).then(res=>{
            this.amount=res.setup_fee;
          this.adyen_server_type=res.adyen_server_type;
          this.client_key=res.adyen_key;
    }) }},

paymentCheck(){
   if(this.resultCode=='Authorised'|| this.resultCode=='Received') {
      this.wizardStepNumber=6
      const data=localStorage.getItem('SIGNUP_DATA');
      const dataModel=JSON.parse(data);
      this.client_id=dataModel?.client_id;
      setTimeout(()=>{
        this._handleServerResponse({resultCode:this.resultCode});
      },10)
    }
    else if(this.resultCode==='Refused' ){
      this.wizardStepNumber=6
     this.setData();
     NotificationService.showNotification({
          text: this.$t('Your payment has been Refused! please try again.'),
          timeout: 3000,
          type: "error",
          });
    }
    else if(this.resultCode=='ConnectionError'){
      this.wizardStepNumber=6
     this.setData();
     NotificationService.showNotification({
          text: this.$t('There was an error connecting to Adyen.! please try again.'),
          timeout: 3000,
          type: "error",
          });
    }
  
    else if(this.resultCode){
      this.wizardStepNumber=6
     this.setData();
     NotificationService.showNotification({
          text: this.$t('Your payment was not successful, please try again.'),
          timeout: 3000,
          type: "error",
          });
    }
},
    setData(){
      console.log('bbbbbbbbbbbb')
      const data=localStorage.getItem('SIGNUP_DATA');
     const dataModel=JSON.parse(data);
     this.currency_code=dataModel.currency_code;
     this.client_name=dataModel.client_name;
     this.client_admin=dataModel.client_admin;
     this.client_address=dataModel.client_address;
     this.postal_code=dataModel.postal_code;
     this.city=dataModel.city;
     this.country=dataModel.country;;
     this.vatID=dataModel.vatID;
     this.client_logo=dataModel.client_logo;
     this.checksum=dataModel.checksum;
     this.users=dataModel.users;
     this.client_id=dataModel.client_id;
     this.support_packages=dataModel.support_packages;
     this.previewImage=dataModel.previewImage;
     this.selectedID=dataModel.selectedID;
     this.summaryPackages=dataModel.summaryPackages; 
     this.is_edit=1;
     this.is_agree=dataModel.is_agree;
     this.validatePassword(dataModel.users[0].password);
     this.checkCity(this.city);
     this.wizardStepNumber=6;
    },
    sortObject(obj) {
      return Object.keys(obj).sort().reduce(function (result, key) {
        result[key] = obj[key];
        return result;
      }, {});
    },
    getTotal() {
      let total = 0;
      if (this.yearly_usage_fees && this.users[0].yearly_paid && this.users[0].booking_flag) {
        total = this.yearly_usage_fees.booking_module;
      }
      else if (this.prorated_usage_fees && !this.users[0].yearly_paid && this.users[0].booking_flag) {
        total = this.prorated_usage_fees.booking_module * 1
      }
      else if (this.yearly_usage_fees && this.users[0].yearly_paid && !this.users[0].booking_flag) {
        total = this.yearly_usage_fees.all_modules;
      }
      else if (this.prorated_usage_fees && !this.users[0].yearly_paid && !this.users[0].booking_flag) {
        total = this.prorated_usage_fees.all_modules * 1
      }
      return total
    },
    getSubscriptionTotal() {
      const totalPackage = this.summaryPackages && this.summaryPackages.reduce((partialSum, a) => partialSum + a.value, 0);
      return totalPackage;
    },
    getNetTotal() {

      const totalPackage = this.summaryPackages && this.summaryPackages.reduce((partialSum, a) => partialSum + a.value, 0);
      return totalPackage + this.getTotal();

    },
    addUser() {
      this.users.push({
        user_name: '', yearly_paid: 0, booking_flag: 0, id: this.users.length + 1
      })
    },
    closeUser(user) {
      this.users = this.users.filter(u => u.id !== user.id)
    },
    uploadImage(e) {
      const image = e.target.files[0];
      this.client_logo = image;
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        this.previewImage = e.target.result;
        setTimeout(() => {
          let ele = document.getElementById('logo-main-box');
          this.imageHeight = ele.clientHeight > 120 ? 90 : ele.clientHeight;
          console.log(this.imageHeight)
        }, 10)
      };
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onCompanyDetailsValidation: function (name, value) {
      this.$set(this.validationCompanyDetailsResult, name, value);
    },
    onUserValidation: function (name, value) {
      this.$set(this.validationUserResult, name, value);
    },
    onInvoiceValidation: function (name, value) {
      this.$set(this.validationInvoiceResult, name, value);
    },
    async onEmailChange(name, value) {
      this.errEmailMessage = null;
      if (validateEmail(value)) {
        this.client_admin = value;
       // this.emailNameSubject.next(value);
      }
    },
    openEye() {
      this.showEye = !this.showEye;
    },
    openConfirmEye() {
      this.showConfirmEye = !this.showConfirmEye;
    },
    // onClientIdvaluechanged: function (name, value) {
    //   this.onValidation("uniqName", { valid: false, errors: ['err'] });
    // },
    onClientIdChange: function (name, value) {
      this.errMessage = null;
       value=value?.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
      this[name] =value;
      if(value.length>=2){
        this.clientSubject.next(value);
      }
      
    },
    onTextFieldValueChange: async function (name, value) {
      this[name] = value;
    },
    onVatTextFieldValueChange(name,value){
      this[name] = value;
      if(value){
        this.vatIdSubject.next(value);
      }
      
    },
    onCityBlur(name, value) {
      this[name] = value;
      if(value){
        this.checkCity(value);
      }
    
    },
    checkCity(value) {
      this.loadingCity = true;
      this.isEu=false;
      SignupService.countriesByCity(value).then((res) => {
        this.loadingCity = false;
        this.countries = createTV(res, 'country', 'country');
        this.country =
          this.countries && this.countries.length > 0
            ? this.countries[0].value
            : "";
            SignupService.isEuCountry(this.country).then((res) => {
              this.isEu=res==1?true:false;
              console.log('aaaaaaa',this.isEu)
              this.vatID = null;
            })

      });
    },
    isRequired(){
      return this.isEu;
    },
    onPaymentRadioChange(action){
      if(action=='card'){
        this.showCard=true;
        this.showSepadirectdebit=false;
        this.displayCard();
      }
      else{
        this.showCard=false;
        this.showSepadirectdebit=true;
        this.displaySepa();
      }

    },
    onRadioChange(pData) {
      this.selectedID = pData.id;
      this.summaryPackages = [];
      if (pData.name.toLowerCase() != 'no support') {
        this.summaryPackages = [
          {
            name: `${pData.name}, Total: ${pData.time} hours`,
            value:0
          },
          {
            name: `One time only sign up Price`,
            value: pData.one_time_bill
          }
        ];
      }

      console.log('this.summaryPackages', this.summaryPackages)

    },
    onCountryChange: function (value) {
      this.country = value.value;
    },
    onUserDropdownChange: function(name, value,user) {
      user.language=value.value;
    },
    onUserTextFieldValueChange(name, value, user) {
      user[name] = value;
      if (name == 'password') {
        this.validatePassword(value);
      }
      if (name == 'staff_email') {
        this.client_admin=value;
      }
    },
    onSetupCheckboxChange: function (event, name) {
      const checked = event.target.checked;
      this[name] = checked;

    },
    onCheckboxChange: function (event, name, user) {
      const checked = event.target.checked;
      user[name] = checked;
      if (name === 'booking_flag') {
        this.selectedID = null;
        this.summaryPackages = [];
      }

    },
    checkUserName(value) {
      return value !== 'details_helper' ? true : false;
    },
    checkConfirmPassword(value) {
      return value == this.users[0].password ? true : false;
    },
    checkPassword(value) {
      return value == this.users[0].confirmPassword ? true : false;
    },
    checkUniq(value) {
      return value == this.duplicateClientId ? false : true;
    },
    checkVatID(value) {
      return value && value == this.duplicateVatID ? false : true;
    },
    checkEmailUniq(value) {
      return value == this.duplicateEmail ? false : true;
    },
    checkEmail(value) {
      return !value ? false : true;
    },
    onCurrencyChange(e) {
      this['currency_code'] = e.value;
    },
    close() {
      this.previewImage = null;
      this.client_logo = '';
      setTimeout(() => {
        let ele = document.getElementById('logo-main-box');
        this.imageHeight = ele.clientHeight > 120 ? 90 : ele.clientHeight;
        console.log(this.imageHeight)
      }, 10)

    },
    getYear() {
      let obj = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
      let month = obj.getUTCMonth() + 1;
      let year = obj.getUTCFullYear();
      return `${month} ${year}`
    },
    getMonth() {
      let obj = new Date();
      let month = obj.getUTCMonth() + 1;
      let year = obj.getUTCFullYear();
      return `${month} ${year}`
    },
    validateLengthClient(value) {
      console.log('value',value)
      if (value &&value.match(/^[a-z0-9_]*$/) &&  value.length >= 3 && value.length<48 ) {
        this.isClientValid=true;
        this.errMessage="";
      } 
      else  {
        this.isClientValid=false;
        this.errMessage=value?'Account name must be at least 3 letters':"";
      }
     return this.isClientValid
      
    },
    ltrim(str) {
  if(!str) return str;
  return str.replace(/^\s+|\s+$/g, '');;
},
    validateClient(value) {
      //validate letter
      if (value && value.match(/^[a-z0-9_]*$/) &&  value.length >= 3 && value.length<48 ) {
        this.isClientValid=true;
        this.errMessage="";
      } 
      else {
        this.isClientValid=false;
        this.errMessage=value && value.length <3?'Account name must be at least 3 letters':value?'Client ID must only contain lowercase letters, numbers, or underscores.':'';
      }

     return this.isClientValid
      
    },
    validatePassword(value) {
      //validate the length
      if (value.length >= 8) {
        this.onUserValidation("length", { valid: true, errors: [] });
      } else {
        this.onUserValidation("length", { valid: false, errors: ["error"] });
      }

      //validate letter
      if (value.match(/[A-z]/)) {
        this.onUserValidation("letter", { valid: true, errors: [] });
      } else {
        this.onUserValidation("letter", { valid: false, errors: ["error"] });
      }

      //validate capital letter
      if (value.match(/[A-Z]/)) {
        this.onUserValidation("capital", { valid: true, errors: [] });
      } else {
        this.onUserValidation("capital", { valid: false, errors: ["error"] });
      }

      //validate number
      if (value.match(/\d/)) {
        this.onUserValidation("number", { valid: true, errors: [] });
      } else {
        this.onUserValidation("number", { valid: false, errors: ["error"] });
      }

      //validate space
      if (value.match(/[^a-zA-Z0-9\-\/]/)) {
        this.onUserValidation("space", { valid: true, errors: [] });
      } else {
        this.onUserValidation("space", { valid: false, errors: ["error"] });
      }
    },
    async onSave() {
      if (!this.is_agree) {
        NotificationService.showNotification({
          text: this.$t('Please read terms and condiondions and agree with it!'),
          timeout: 3000,
        });
        return;
      }
      this.loading = true;
      const booking_flag = this.users[0].booking_flag ? 1 : 0;
      const yearly_paid = this.users[0].yearly_paid ? 1 : 0;
      const users = this.users.map(u => {
        return {
          user_name: u.user_name,
          language: u.language,
          staff_email: u.staff_email,
          password: u.password
        }
      })
      localStorage.setItem('SIGNUP_DATA', JSON.stringify({client_id: this.client_id,
        currency_code: this.currency_code,
        client_name: this.client_name,
        client_admin: this.client_admin,
        client_address: this.client_address,
        postal_code: this.postal_code,
        city: this.city,
        country: this.country,
        vatID: this.vatID,
        client_logo: this.client_logo,
        checksum: this.checksum,
        booking_flag: booking_flag,
        yearly_paid: yearly_paid,
        setup_fee: this.getNetTotal(),
        support_packages:this.support_packages,
        summaryPackages:this.summaryPackages,
        selectedID:this.selectedID,
        users:this.users,
        previewImage:this.previewImage,
        is_edit:this.is_edit,
        is_agree:this.is_agree,
        settings: {
         ...users[0]
          
        }}))
    
      console.log({
        client_id: this.client_id,
        currency_code: this.currency_code,
        client_name: this.client_name,
        client_admin: this.client_admin,
        client_address: this.client_address,
        postal_code: this.postal_code,
        city: this.city,
        country: this.country,
        vatID: this.vatID,
        client_logo: this.client_logo,
        checksum: this.checksum,
        booking_flag: booking_flag,
        yearly_paid: yearly_paid,
        setup_fee: this.getNetTotal(),
        settings: {
         ...users[0]
          
        }
      })
      const res = await SignupService.createClient(
        {
          client_id: this.client_id,
          currency_code: this.currency_code,
          client_name: this.client_name,
          client_admin: this.client_admin,
          client_address: this.client_address,
          postal_code: this.postal_code,
          city: this.city,
          country: this.country,
          vatID: this.vatID,
          client_logo: this.client_logo,
          checksum: this.checksum,
          is_edit: this.is_edit ? 1 : 0,
          booking_flag: booking_flag,
          yearly_paid: yearly_paid,
          setup_fee: this.getNetTotal(),
          settings: JSON.stringify({
            ...users[0]
          } )
        });
        console.log('done',res)
        if(res.data.done>0){
          SignupService.getPaymentFormData({client_id:this.client_id,checksum:this.checksum}).then(res1=>{
            this.amount=res1.setup_fee;
          this.adyen_server_type=res1.adyen_server_type;
          this.client_key=res1.adyen_key;
          this.wizardStepNumber++;
          this.isDone=true;
          console.log('res1',res1);
          NotificationService.showNotification({
          text: this.$t('Client created Successfully!!'),
          timeout: 3000,
          });
         this.loading = false;
         this.is_edit = true;
          });
      
        }
        else{
          this.loading = false;
          NotificationService.showNotification({
          text: this.$t('Invalid Client!!. Please try again!'),
          timeout: 3000,
          });
        }

    
     
    },
    daysInThisMonth() {
  var now = new Date();
  return new Date(now.getFullYear(), now.getMonth()+1, 0).getDate();
},
    getMonthEnd(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
},

 getMonthDaysLeft(date = new Date()) {
  return this.getMonthEnd(date).getDate() - date.getDate();
},
    displaySepa() {
      this.hideErr();
      this.hideAllPaymentTypeBoxes();
      this.showSepadirectdebit = true;
      this.initCheckout("sepadirectdebit");
    },
    displayCard() {
      this.hideErr();
      this.hideAllPaymentTypeBoxes();
      this.showCard = true;
      this.initCheckout("card");
    },
    async initCheckout(type = "card") {
      try {
        this.payment_method = type;
        const configuration = {
          paymentMethodsResponse: this.filterUnimplemented({
            paymentMethods: ["scheme", "sepadirectdebit"],
          }),
          clientKey: this.client_key,
          locale: "en_US",
          environment: this.adyen_server_type,
          showPayButton: true,
          paymentMethodsConfiguration: {
            ideal: {
              showImage: true,
            },
            card: {
              hasHolderName: true,
              holderNameRequired: true,
              name: "Credit or debit card",
              amount: {
                value: this.amount*100,
                currency: "EUR",
              },
              billingAddressRequired: true,
            },
          },
          onSubmit: (state, component) => {
            if (state.isValid) {
              this.handleSubmission(state, component, "make_payment_v2");
            }
          },
          onAdditionalDetails: (state, component) => {
            this.handleSubmission(state, component, "update_billing_info_3ds");
          },
        };
        const AdyenCheckout = (await import("@adyen/adyen-web")).default;

        AdyenCheckout(configuration).then((checkout) => {
          checkout.create(type).mount(document.getElementById(type));
        });
      } catch (error) {
        console.error(error);
      }
    },
    filterUnimplemented(pm) {
      pm.paymentMethods = pm.paymentMethods.filter((it) =>
        [
          "scheme",
          "ideal",
          "dotpay",
          "giropay",
          "sepadirectdebit",
          "directEbanking",
          "ach",
          "alipay",
        ].includes(it.type)
      );
      return pm;
    },
    async handleSubmission(state, component, action) {
      try {
        let { data } = state;
        data.action = action;
        data.riskData = JSON.stringify(data?.riskData || {});
        data.browserInfo = JSON.stringify(data?.browserInfo || {});
        data.paymentMethod = JSON.stringify(data?.paymentMethod || {});
        data.billingAddress = JSON.stringify(data?.billingAddress || {});
        data.amount = JSON.stringify(
          {
            value: this.amount*100,
            currency: "EUR",
          } || {}
        );
        data.client_id = this.client_id;
        data.checksum  = this.checksum;
        data.payment_method = this.payment_method;
        const res = await this.callServer(data);
        this.handleServerResponse(res, component);
      } catch (error) {
        console.error(error);
      }
    },
    async callServer(params) {
      let urlSearchParams = new URLSearchParams();
      for (const k in params) {
        urlSearchParams.append(k, params[k]);
      }
      // console.log(params);
      let headers = new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      });
     // let request = new Request(`signup.cgi`, );
     const otherParams={
        method: "POST",
        headers: headers,
        body: urlSearchParams,
        credentials: "include",
      }

      const res = await fetch(`${HttpClient.baseUrl}/signup.cgi`,otherParams);

      return await res.json();
    },

    async handleServerResponse(res, component) {
     
     if (res.action) {
        component.handleAction(res.action);
      } 
      else {
        console.log("resultCode", "resultCode");

        this._handleServerResponse(res);
      }
    },

    _handleServerResponse(res) {
      const resultContainerDiv = document.getElementById(`resultPaymentFail`);
      resultContainerDiv.classList.remove(
        "bg-success",
        "bg-warning",
        "bg-danger",
        "text-white",
        "text-dark"
      );
      switch (res.resultCode) {
        case "Authorised":
          this.errPaymentMessage = `Your payment has been successfully placed.`;
          resultContainerDiv.style = `background-color: #28a745 !important;
          color: white;padding:5px 20px;margin:10px 2px`;
          setTimeout(()=>{
             localStorage.removeItem('SIGNUP_DATA');
             window.location.replace(`${HttpClient.baseUrl}/${this.client_id}/v2/#/main/login`);
          },3000)
          break;

        case "Pending":
        case "Received":
          this.errPaymentMessage = `Your payment has been received! Payment completion pending.`;
          resultContainerDiv.style = `background-color: #ffc107!important;
          color: white;padding:5px 20px;margin:10px 2px`;
          setTimeout(()=>{
             localStorage.removeItem('SIGNUP_DATA');
             window.location.replace(`${HttpClient.baseUrl}/${this.client_id}/v2/#/main/login`);
          },3000)
          break;

        case "Refused":
          this.errPaymentMessage = `Your payment has been Refused! please try again.`;
          resultContainerDiv.style = `background-color: #ffc107!important;
          color: white;padding:5px 20px;margin:10px 2px`;
          break;

        case "ConnectionError":
          this.errPaymentMessage = `There was an error connecting to Adyen. status:${res.status_line}. content:${res.content}`;
          resultContainerDiv.style = `background-color: #dc3545!important;
          color: white;padding:5px 20px;margin:10px 2px`;
          break;

        case "other":
          this.errPaymentMessage = res.content;
          resultContainerDiv.style = `background-color: #dc3545!important;
         color: white;padding:5px 20px;margin:10px 2px`;
          break;

        default:
          this.errPaymentMessage = `Your payment was not successful, please try again.`;
          resultContainerDiv.style = `background-color:#dc3545!important;
          color: white;padding:5px 20px;margin:10px 2px`;
          break;
      }
      this.hideAllPaymentTypeBoxes();
    },
    hideAllPaymentTypeBoxes() {
      this.showCard = false;
      this.showSepadirectdebit = false;
     
    },
    hideErr(){
      this.errPaymentMessage='';
      const resultContainerDiv = document.getElementById(`resultPaymentFail`);
      if(resultContainerDiv){
        resultContainerDiv.classList.remove(
        "bg-success",
        "bg-warning",
        "bg-danger",
        "text-white",
        "text-dark"
      );
      }
    }
  },
};
</script>

<style lang="scss">

.signup-page {
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-size:13px !important;
  height: 100%;


  .signup-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    gap: 2rem;
    align-items: center;
    height: 100vh;
    font-size:13px !important;
    


    .left-box {
      width: 30%;
      max-width: 30%;
      background-color: var(--bc-6);
      flex-direction: column;
      display: flex;
      justify-content: center;
      height: 100%;

      .logo {
        text-align: center;
        padding: 5px;

        img {
          width: 120px;
        }

      }

      .text-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
      }
    }

    .right-box {
      flex-direction: column;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
     
      .dt-input-box--container .dt-input-box .input-container  input:autofill{
        -webkit-box-shadow:none !important;
      }
      .stepper {
        width: 100%;
        box-shadow: none;
        height: 100%;
        margin-top: 30px;


        .stepper__items {
          height: calc(100% - 155px);
          overflow-y: auto;
          padding-top: 30px;
          max-width: 1250px;
        }

        .stepper__header {
          box-shadow: none;
          justify-content: center;
          height: fit-content;
          max-width: 1250px;
        }

        .stepper__step--complete .primary {
          background-color: #50e890 !important;
          border-color: #50e890 !important;
        }
      }


      .field-content {
        display: flex;
        align-items: center;

      }

      .pw_validation {
        padding: 20px 0px;

        ul {
          list-style: none;
          padding: 5px 0px;

          li img {
            vertical-align: middle;
            padding: 0px 2px;
          }
        }
      }

      .signup-box {
        -webkit-box-flex: 1;
        flex: auto;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        padding-right: 15px;

        .form-container {
          flex: 1;
          width: 100%;
          max-width: 450px;
          align-content: center;
          justify-content: space-between;
          display: flex;
          flex-direction: column;
        }
      }

      .summary-container {
        box-shadow: 0px 0px 15px 3px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        max-height: 100%;
        height: fit-content;
        padding: 20px;
        max-width: 425px;
        max-height: fit-content;
         padding: 40px 24px;
      }

      .value-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }



      .btn-signup {
        background-color: #007bff;
        border: 0px;
        color: white;
        width: 100%;
        border-radius: 5px;
        margin: 0px !important;
        padding: 0px !important;
      }

      .options {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        padding-right: 90px;
        width: 100%;
        max-width: 1024px;
        margin: 0 auto;
      }

      .stepper__step {
        padding: 20px !important;
      }

      .Neon {
        font-family: sans-serif;
        color: #494949;
        position: relative;


      }

      .Neon-input-dragDrop {
        display: block;
        width: 200px;
        padding: 20px 0px;
        color: var(--sprt-3);
        background: #f5f5f5;
        border: 2px dashed #C8CBCE;
        border-radius: 10px;
        text-align: center;

      }

      .Neon-input-dragDrop .Neon-input-icon {
        font-size: 48px;
        margin-top: -10px;

      }

      .Neon-input-text span {
        font-size: 12px;
      }

      .Neon-input-choose-btn.browse {
        color: var(--sprt-3);
        border: 1px solid var(--sprt-3);
        border-radius: 5px;
      }

      .Neon-input-choose-btn {
        display: inline-block;
        padding: 8px 14px;
        outline: none;
        cursor: pointer;
        text-decoration: none;
        text-align: center;
        white-space: nowrap;
        font-size: 12px;
        font-weight: bold;
        color: #8d9496;
        border-radius: 3px;
        border: 1px solid #c6c6c6;
        vertical-align: middle;
        background-color: #fff;

      }
    }


  }

  .logo-box {
    display: grid;
    place-items: center;
    flex: 1;
    margin: 10px;
    height: calc(100% - 25px);
    position: relative;
    max-width: 250px;
    max-height: 250px;
    cursor: pointer;

    .logo-image {
      height: 100%;
      width: 100%;
      max-height: 100%;
      max-width: 100%;

      cursor: pointer;
    }

    .dt-icon {
      opacity: 0;
      position: absolute;
      background: white;
      top: -15px;
      right: -20px;
      opacity: 9;
    }
  }
}

.support-package {
  padding-bottom: 10px;

  legend {
    font-size: 13px;
    font-weight: bold;
    padding: 3px 6px;
  }

  input {
    margin: 0.4rem;
  }
  .package-content{
    display: flex;
  flex-direction: row;
  gap:2rem;
  max-width: 500px;
  width:100%;
  min-height: 220px;
  padding-bottom: 10px;
  justify-content: space-between;
  align-items: flex-start;
  background: #ffffff 0% 0% no-repeat padding-box;
  border:  1px solid #C8C8C8;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 16px;
  &.not-support{
    background: #ffffff 0% 0% no-repeat padding-box;
  border: none;
  border-radius:none;
  }
  }


}

@media only screen and (max-width: 600px) {
  .signup-container {
    .right-box {
      .stepper {
        margin: 35px auto !important;
        padding-top: 0px !important;
        .stepper__items {
          height: calc(100% - 150px) !important;
          overflow-y: auto;
          padding-top: 30px;
        }
      }
    }
  }
}
</style>